import { Controller } from "@hotwired/stimulus"

// Shared FAQ toggle controller for expandable FAQ items
// Used by: pages (cms/faq_item_component), partner_portal (faq/index)
export default class extends Controller {
  static targets = ["container", "button", "answer", "icon"]

  toggle() {
    const isExpanded = this.buttonTarget.getAttribute("aria-expanded") === "true"

    this.buttonTarget.setAttribute("aria-expanded", !isExpanded)
    this.answerTarget.classList.toggle("hidden")

    // Toggle border styling on container if present
    if (this.hasContainerTarget) {
      this.containerTarget.classList.toggle("border-gray-300")
      this.containerTarget.classList.toggle("border-ph24_blue")
    }

    if (isExpanded) {
      this.iconTarget.classList.remove("rotate-45")
    } else {
      this.iconTarget.classList.add("rotate-45")
    }
  }
}
